import {
  CREATE_NEW_PROFILES_MODAL_MANUAL_IDENTIFIER,
  CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER
} from '../constants/common';

import {
  CreateNewProfilesOpenedOn
} from '../types/CreateNewProfiles.type';
import {
  SetOfButtonsForCreateNewProfilesConfirmationModal,
  SetOfButtonsForCreateNewProfilesModal
} from '../types/modals';

interface TextAndAction {
  text: string,
  action: () => void
}

interface TextsAndActionsDictionaryForCreateNewProfilesModal {
  cancel: TextAndAction,
  next: TextAndAction,
  back: TextAndAction,
  save: TextAndAction
}

interface ManualFormState {
  type: typeof CREATE_NEW_PROFILES_MODAL_MANUAL_IDENTIFIER
}

interface TemplateFormState {
  type: typeof CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER,
  data: null | { type: 'unsuccessful-upload' } | { type: 'successful-upload' }
}

type CreatenewProfilesModalState =
  | ManualFormState
  | TemplateFormState;

export const getSetOfButtonsForCreateNewProfilesModal = (
  createEntitiesModal: CreatenewProfilesModalState,
  textAndActions: TextsAndActionsDictionaryForCreateNewProfilesModal
): SetOfButtonsForCreateNewProfilesModal => {
  if (createEntitiesModal.type === CREATE_NEW_PROFILES_MODAL_MANUAL_IDENTIFIER) {
    return [
      {
        type: 'tertiary',
        ...textAndActions.cancel
      },
      {
        type: 'primary',
        ...textAndActions.save
      }
    ];
  }

  if (
    createEntitiesModal.data === null
    || createEntitiesModal.data.type === 'unsuccessful-upload'
  ) {
    return [
      {
        type: 'tertiary',
        ...textAndActions.cancel
      },
      {
        type: 'secondary',
        ...textAndActions.next
      }
    ];
  }

  return [
    {
      type: 'tertiary',
      ...textAndActions.cancel
    },
    {
      type: 'secondary',
      ...textAndActions.back
    },
    {
      type: 'primary',
      ...textAndActions.save
    }
  ];
};

interface TextsAndActionsDictionaryForConfirmationModal {
  okay: TextAndAction,
  close: TextAndAction,
  continue: TextAndAction
}

export const getSetOfButtonsForCreateNewProfilesConfirmationModal = (
  openedOn: CreateNewProfilesOpenedOn,
  wantToCreateNew: boolean,
  textAndAction: TextsAndActionsDictionaryForConfirmationModal
): SetOfButtonsForCreateNewProfilesConfirmationModal => {
  if (openedOn === 'custom-collection') {
    return [{
      type: 'secondary',
      ...textAndAction.okay
    }];
  }

  if (wantToCreateNew) {
    return [
      {
        type: 'tertiary',
        ...textAndAction.close
      },
      {
        type: 'secondary',
        ...textAndAction.continue
      }
    ];
  }

  return [{
    type: 'secondary',
    ...textAndAction.close
  }];
};
